const homeLayoutRoutes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  // {
  //   path: '/contact-us',
  //   name: 'Contact Us',
  //   component: () => import('@/views/ContactUs.vue')
  // },
  {
    path: '/register',
    name: 'User Registration',
    component: () => import('@/views/MerchantRegistration.vue')
  },
  // {
  //   path: '/login',
  //   name: 'User Login',
  //   component: () => import('@/views/UserLogin.vue')
  // },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: () => import('@/views/ForgotPassword.vue')
  },
  {
    path: '/validate-email',
    name: 'Validate Email',
    component: () => import('@/views/ValidateEmail.vue')
  },
  {
    path: '/not-found',
    name: 'Error',
    component: () => import('@/views/NotFound.vue')
  }
]

export default homeLayoutRoutes
